import React from 'react';
import Hero from '../components/Hero';
import heroImage from '../assets/hero.jpg';
import donkeyLogo from '../assets/donkey_logo.png';
import './Music.css';

const Music: React.FC = () => {
  return (
    <div className="music-page">
      <Hero
        title="Music"
        image={heroImage}
        height="40vh"
        useClipPath={true}
        chevronLogo={donkeyLogo}
      />

      <main className="page-content">
        <div className="container">
          <section className="text-center mb-5">
            <h2 style={{ fontFamily: 'Damion, cursive', fontSize: '3rem', marginTop: '2rem' }}>
              Karaoke Nights
            </h2>
            <p className="lead" style={{ fontSize: '1.5rem', marginTop: '1rem' }}>
              Join us every Wednesday & Friday
              <br />
              <span style={{ fontSize: '1.25rem', color: '#666' }}>9:00 PM until Close</span>
            </p>
          </section>

          <section className="text-center mb-5">
            <h2 style={{ fontFamily: 'Damion, cursive', fontSize: '2.5rem' }}>
              Live Bands & Special Events
            </h2>
            <p className="lead" style={{ fontSize: '1.25rem', marginBottom: '2rem' }}>
              We regularly feature amazing local bands and special musical performances.
              Follow us on social media to stay updated on our upcoming shows!
            </p>
          </section>

          <section className="text-center booking-section" style={{ marginTop: '3rem' }}>
            <h3 style={{ fontFamily: 'Damion, cursive', fontSize: '2.5rem' }}>Want to Perform?</h3>
            <p className="lead" style={{ fontSize: '1.25rem', marginBottom: '1rem' }}>
              We're always looking for talented performers to join our lineup!
            </p>
            <p className="contact-info" style={{ fontSize: '1.25rem' }}>
              For booking inquiries, call: <br />
              <a href="tel:14083202466" style={{
                color: '#007bff',
                textDecoration: 'none',
                fontSize: '1.5rem',
                fontWeight: 'bold'
              }}>
                (408) 320-2466
              </a>
            </p>
          </section>
        </div>
      </main>
    </div>
  );
};

export default Music; 